import type { ComponentProps, ReactNode } from "react";

import { env } from "@/env";
import { focusRing } from "@/ui";

type PersonifyButtonProps = Omit<ComponentProps<"a">, "href" | "className"> & {
  children: ReactNode;
};

export const PersonifyButton = ({ children, ...props }: PersonifyButtonProps) => {
  return (
    <a
      className={`flex h-14 items-center justify-center gap-3 rounded-full border border-line-strong bg-surface px-5 font-semibold text-personify transition-colors hover:border-personify hover:bg-surface-hover ${focusRing}`}
      href={`${env.VITE_API_URL}/webapp/auth/oidc/start`}
      {...props}
    >
      <img
        alt=""
        aria-hidden="true"
        className="size-9 shrink-0 -rotate-[8deg]"
        src="/assets/images/personify-percy.png"
      />
      <span className="text-base leading-tight">
        {children}
        <sup className="text-xs">™</sup>
      </span>
    </a>
  );
};
